var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "882aff126a0b25d8e50e40319a73682b3da74499"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dfh-corp-sites@designs-for-health"] = {
  id: "882aff126a0b25d8e50e40319a73682b3da74499"
};